export default function Footer(){
    return(
        <div className="flex h-20 mt-10 bg-gray-400"></div>
    )
}